import { AccessTime, ArrowDownward, ArrowUpward, CheckCircle, Close, Download, ExpandMore, Flag, Info, InfoOutlined, MoreVert, Notifications, Radar, Refresh, Save, Update, Warning } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, LinearProgress, Slider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Tooltip as MuiTooltip } from '@mui/material';
import React, { Component } from 'react';
import Global from '../../customlib/Global';
import Api from '../../customlib/Api';
import DateRangePickerRich from '../../customlib/DateRangePickerRich';
import moment from 'moment';
import axios from 'axios';
import { ShimmerCategoryItems, ShimmerContentBlock, ShimmerText, ShimmerTitle } from 'shimmer-effects-react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Title } from 'chart.js';
import { Bar, Pie, Doughnut } from 'react-chartjs-2';
import ExportAgentsPerforma from './ExportAgentsPerforma';
import ChatViewer from './ChatViewer';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, 
    CategoryScale,
    LinearScale,
    BarElement,
    Title);
class SpvControlPanel extends Component {
    state = { 
        startDate: moment(),
        endDate: moment(),
        selectedAgent: null,
        leadsSummaryData: null,
        closingRateSummaryData: null,
        firstResponseSummaryData: null,
        redFlagAgentsData: null,
        agentsPerformaData: null,
        summaryAlasanTidakClosingAllAgentsData: null,
        summaryLeadsTemperatureAllAgentsData: null,
        isLoadingLeadsSummary: false,
        isLoadingClosingRateSummary: false,
        isLoadingFirstResponseSummary: false,
        isLoadingAgentsPerforma: false,
        isLoadingSummaryAlasanTidakClosingAllAgents: false,
        isLoadingSummaryLeadsTemperatureAllAgents: false,
        summaryAlasanTidakClosingChartData: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgb(235, 54, 178)',
                    'rgb(54, 235, 84)',
                    'rgb(22, 64, 107)',
                    'rgb(141, 151, 11)',
                    'rgb(16, 107, 63)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgb(235, 54, 178)',
                    'rgb(54, 235, 84)',
                    'rgb(22, 64, 107)',
                    'rgb(141, 151, 11)',
                    'rgb(16, 107, 63)',
                ],
                borderWidth: 1,
                },
            ],
        },
        summaryLeadsTemperatureChartData: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgb(235, 54, 178)',
                    // 'rgb(54, 235, 84)',
                    // 'rgb(22, 64, 107)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgb(235, 54, 178)',
                    // 'rgb(54, 235, 84)',
                    // 'rgb(22, 64, 107)',
                ],
                borderWidth: 1,
                },
            ],
        },
        showDialog: false,
        sortMethod: "ASC",//ASC, DESC
        override: false
    }

    loadLeadsSummary = () => {
        this.setState({isLoadingLeadsSummary: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                  appProfileId: Global.getAppProfile()._id,
                  override: this.state.override
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelLeadsSummary(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                this.setState({leadsSummaryData: data.data, isLoadingLeadsSummary: false});
            })
            .catch((error) => {
                this.setState({isLoadingLeadsSummary: false});
                console.error("There was an error!", error);
            });
        })
        

    }

    loadClosingRateSummary = () => {
        this.setState({isLoadingClosingRateSummary: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                appProfileId: Global.getAppProfile()._id,
                override: this.state.override
                //appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelClosingRateSummary(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                this.setState({closingRateSummaryData: data.data, isLoadingClosingRateSummary: false});
            })
            .catch((error) => {
                this.setState({isLoadingClosingRateSummary: false});
                console.error("There was an error!", error);
            });
        });

    }

    loadAvgResponseSummary = () => {
        this.setState({isLoadingFirstResponseSummary: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                  appProfileId: Global.getAppProfile()._id,
                  override: this.state.override
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelFirstResponseSummary(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                this.setState({firstResponseSummaryData: data.data, isLoadingFirstResponseSummary: false});
            })
            .catch((error) => {
                this.setState({isLoadingFirstResponseSummary: false});
                console.error("There was an error!", error);
            });
        })

    }

    loadSummaryAlasanTidakClosingAllAgents = () => {
        this.setState({isLoadingSummaryAlasanTidakClosingAllAgents: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                  appProfileId: Global.getAppProfile()._id,
                  override: this.state.override
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelSummaryAlasanTidakClosingAllAgents(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                const chartData = {...this.state.summaryAlasanTidakClosingChartData}
                chartData.labels = [];
                chartData.datasets[0].data = [];
                if(Array.isArray(data.data)){
                    data.data?.forEach(element => {
                        chartData.labels.push(`${element.alasan_tidak_closing} (${element.count})`);
                        chartData.datasets[0].data.push(element.count);
                    });
                }else{
                    chartData.labels.push(data.data.alasan_tidak_closing);
                    chartData.datasets[0].data.push(data.data.count);
                }
                

                this.setState({summaryAlasanTidakClosingAllAgentsData: data.data, summaryAlasanTidakClosingChartData: chartData, isLoadingSummaryAlasanTidakClosingAllAgents: false});
            })
            .catch((error) => {
                this.setState({isLoadingSummaryAlasanTidakClosingAllAgents: false});
                console.error("There was an error!", error);
            });
        })

    }

    loadSummaryLeadsTemperatureAllAgents = () => {
        this.setState({isLoadingSummaryLeadsTemperatureAllAgents: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                  appProfileId: Global.getAppProfile()._id,
                  override: this.state.override
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelSummaryLeadsTemperatureAllAgents(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                const chartData = {...this.state.summaryLeadsTemperatureChartData}
                chartData.labels = [];
                chartData.datasets[0].data = [];
                if(Array.isArray(data.data)){
                    data.data?.forEach(element => {
                        chartData.labels.push(`${element.temperature} (${element.count})`);
                        chartData.datasets[0].data.push(element.count);
                    });
                }else{
                    chartData.labels.push(data.data.temperature);
                    chartData.datasets[0].data.push(data.data.count);
                }
                

                this.setState({summaryLeadsTemperatureAllAgentsData: data.data, summaryLeadsTemperatureChartData: chartData, isLoadingSummaryLeadsTemperatureAllAgents: false});
            })
            .catch((error) => {
                this.setState({isLoadingSummaryLeadsTemperatureAllAgents: false});
                console.error("There was an error!", error);
            });
        })

    }

    loadSummaryAlasanTidakClosingAgents = () => {
        this.setState({isLoadingSummaryAlasanTidakClosingAgents: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                appProfileId: Global.getAppProfile()._id,
                agentId: this.state.selectedAgent?.agentId
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelSummaryAlasanTidakClosingAllAgents(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                const selected = {...this.state.selectedAgent};
                const agentPerforma = {...this.state.agentsPerformaData};
                selected.summaryAlasanTidakClosingData = data.data;

                const findAgentPerforma = agentPerforma.byAgents?.find(agent => agent.agentId === selected.agentId);
                if(findAgentPerforma){
                    if(Array.isArray(data.data)){
                        findAgentPerforma.summaryAlasanTidakClosingData = data.data;
                        selected.summaryAlasanTidakClosingData = data.data;
                    }else{
                        findAgentPerforma.summaryAlasanTidakClosingData = [data.data];
                        selected.summaryAlasanTidakClosingData = [data.data];
                    }
                    
                }

                this.setState({agentsPerformaData: agentPerforma, selectedAgent: selected, isLoadingSummaryAlasanTidakClosingAgents: false}, () => {
                    console.log("SELECTED_AGENT", this.state.selectedAgent);
                });
            })
            .catch((error) => {
                this.setState({isLoadingSummaryAlasanTidakClosingAgents: false});
                console.error("There was an error!", error);
            });
        })

    }

    loadAgentsPerforma = () => {
        this.setState({isLoadingAgentsPerforma: true, agentsPerformaData: null}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                  appProfileId: Global.getAppProfile()._id,
                  override: this.state.override
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.spvCpanelAgentsPerforma(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                let redFlagAgentsCount = 0;
                if (data.data) {
                    redFlagAgentsCount = data.data.byAgents.filter(agent => agent.redFlagCount > 0).length;
                }

                this.setState({agentsPerformaData: data.data, isLoadingAgentsPerforma: false, redFlagAgentsData: redFlagAgentsCount});
            })
            .catch((error) => {
                this.setState({isLoadingAgentsPerforma: false});
                console.error("There was an error!", error);
            });
        })

    }

    handleCoachingNoteChange = (event) => {
        const selectedAgent = {...this.state.selectedAgent};
        const allAgents = {...this.state.agentsPerformaData};

        const findAgent = allAgents.byAgents.find(agent => agent.agentId === selectedAgent.agentId);
        if(findAgent){
            findAgent.coachingNote = event.target.value;
        }
        selectedAgent.coachingNote = event.target.value;

        this.setState({selectedAgent: selectedAgent, agentsPerformaData: allAgents});
    }

    saveAgentsPerforma = () => {
        this.setState({isSavingAgentsPerforma: true}, () => {
            const params = {
                startDate: this.state.startDate.format("YYYY-MM-DD"),
                endDate: this.state.endDate.format("YYYY-MM-DD"),
                appProfileId: Global.getAppProfile()._id,
                leadsSummaryData: this.state.leadsSummaryData,
                closingRateSummaryData: this.state.closingRateSummaryData,
                firstResponseSummaryData: this.state.firstResponseSummaryData,
                agentsPerformaData: this.state.agentsPerformaData,
                topNoClosingData: null,
                summaryAlasanTidakClosingData: this.state.summaryAlasanTidakClosingAllAgentsData,
                summaryLeadsTemperatureData: this.state.summaryLeadsTemperatureAllAgentsData,
                leadsTemperatureData: null
                // appProfileId: "615a83776b646cb1936d6f05"
            };
            
            console.log("ERROR_LOG", params);
            
            axios
            .post(Api.saveAgentsPerforma(), params, Api.getRequestHeader())
            .then((response) => {
                const data = response.data;

                this.setState({isSavingAgentsPerforma: false});
            })
            .catch((error) => {
                this.setState({isSavingAgentsPerforma: false});
                console.error("There was an error!", error);
            });
        })
        

    }

    handleShowDialog = () => {
        if(this.state.selectedAgent){
            this.setState({showDialog: true});
        }
    }

    handleSelectAgent = (agent) => {
        this.setState({selectedAgent: agent}, () => {
            this.loadSummaryAlasanTidakClosingAgents();
        });
    }

    reloadAll = () => {
        this.setState({selectedAgent: null}, () => {
            this.loadLeadsSummary();
            this.loadClosingRateSummary();
            this.loadAvgResponseSummary();
            this.loadAgentsPerforma();
            this.loadSummaryAlasanTidakClosingAllAgents();
            this.loadSummaryLeadsTemperatureAllAgents();
        });
    }

    handleDateChange = (arrDates) => {
        console.log("RANGEDATE", arrDates);
        this.setState({startDate: arrDates[0], endDate: arrDates[1]}, () => {
            this.reloadAll();
        });
    }

    getColor = (value) => {
        if(value <= 50){
            return "error";
        }else if(value > 50 && value <= 80){
            return "warning";
        }else if(value > 81){
            return "success";
        }
    }

    componentDidMount() {
        this.reloadAll();
    }

    render() { 
        return (
            <Box sx={{margin: "10px", p: "10px"}}>
                <Grid container spacing={1}>
                    <Grid item xs={10}>
                        <Typography variant='h6'>Supervisor Control Panel</Typography>
                        <Box>
                            Monitoring Performa Tim dan Kepatuhan SOP
                        </Box>
                    </Grid> 
                    <Grid item xs={2}>
                        <Grid container spacing={1}>
                            <Grid item xs={2} sx={{borderRight: "solid 2px #dededd", alignContent: "center"}}>
                                <Box>
                                    <Notifications />
                                </Box>
                            </Grid>
                            <Grid item xs={10}>
                                <Grid container spacing={1}>
                                    <Grid item xs={2} sx={{alignContent: "center"}}>
                                        <Avatar sx={{width: "30px", height: "30px"}} />
                                    </Grid>
                                    <Grid item xs={10}>
                                        <Box sx={{fontWeight: "bold"}}>{Global.get().user.name}</Box>
                                        <Box sx={{fontWeight: "normal", color: "#474747"}}><small>-</small></Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid> 
                </Grid>
                <Divider sx={{mt: '10px'}} />
                <Grid container spacing={1}>
                    <Grid item xs={this.state.selectedAgent ? 8 : 12}>
                        {/* filter bar */}
                        <Box>
                            <Grid container spacing={1} sx={{mt: "10px"}}>
                                <Grid item xs={3}>
                                    {/* <Box sx={{mt: "4px"}}></Box> */}
                                    <DateRangePickerRich onDateChanged={this.handleDateChange} />
                                </Grid>
                                <Grid item xs={6} textAlign={"left"}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={3}>
                                            <Button disabled={this.state.isLoadingLeadsSummary || this.state.isLoadingAgentsPerforma || this.state.isLoadingClosingRateSummary || this.state.isLoadingFirstResponseSummary} onClick={this.reloadAll} size='small' variant='outlined' color='default' sx={{textTransform: "capitalize"}}>
                                                <Refresh />&nbsp;Reload
                                            </Button>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"left"}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size='small'
                                                        checked={this.state.override}
                                                        onChange={(event) => this.setState({override: event.target.checked})}
                                                        disabled={this.state.isLoadingLeadsSummary || this.state.isLoadingAgentsPerforma || this.state.isLoadingClosingRateSummary || this.state.isLoadingFirstResponseSummary || this.state.isLoadingSummaryAlasanTidakClosingAllAgents || this.state.isLoadingAgentsPerforma }
                                                    />
                                                }
                                                label="Override saved value"
                                            />
                                        </Grid>
                                    </Grid>
                                    
                                    
                                    {/* <IconButton onClick={this.reloadAll} color='primary'><Refresh /></IconButton> */}
                                    {/* <DateRangePickerRich /> */}
                                </Grid>
                                <Grid item xs={3} sx={{textAlign: "right"}}>
                                    <Button onClick={this.saveAgentsPerforma} size='small' variant='outlined' color='default' sx={{textTransform: "capitalize"}}>
                                        <Save />&nbsp;Simpan
                                    </Button>
                                    &nbsp;
                                    <ExportAgentsPerforma agentsPerformaData={this.state.agentsPerformaData?.byAgents ?? []} />
                                    {/* <Button size='small' variant='outlined' color='default' sx={{textTransform: "capitalize"}}>
                                        <Download />&nbsp;Export
                                    </Button> */}
                                </Grid>
                            </Grid>
                        </Box>
                        {/* filter bar */}

                        {/* Content */}
                        <Box sx={{mt: "20px"}}>
                            {/* Summary Boxes */}
                            <Grid container spacing={1}>
                                <Grid item xs={this.state.selectedAgent ? 3 : 2}>
                                    <Box sx={{border: "solid 1px #039f27", backgroundColor: "#d1fbd1", p: "10px", borderRadius: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3} sx={{alignContent: "center"}}>
                                                <Radar sx={{width: "30px", height: "30px", color: "#09d528"}} />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Box sx={{fontWeight: "bold", fontSize: '13px'}}>Total Leads</Box>
                                                {this.state.isLoadingLeadsSummary && <ShimmerTitle mode="light" line={1} gap={21} width={20}/>}
                                                {!this.state.isLoadingLeadsSummary && 
                                                    <Box sx={{fontWeight: "bold", color: "#000000", fontSize: "20px"}}>{this.state.leadsSummaryData?.leadsCount}</Box>
                                                }
                                                
                                            </Grid>
                                        </Grid>
                                        <Box>
                                            
                                            {this.state.isLoadingLeadsSummary && <ShimmerText mode="light" line={1} gap={5} />}
                                            {!this.state.isLoadingLeadsSummary && 
                                                <Box>
                                                    {
                                                        this.state.leadsSummaryData?.isUp ? <ArrowUpward sx={{color: "#038516", width: "10px"}} /> : <ArrowDownward sx={{color: "#038516", width: "10px"}} />
                                                    }
                                                    <span style={{fontSize: "10px"}}>&nbsp;{this.state.leadsSummaryData?.percentage} dari {moment(this.state.leadsSummaryData?.startDateLast30Days).tz("asia/jakarta").format("D MMM")} - {moment(this.state.leadsSummaryData?.endDateLast30Days).tz("asia/jakarta").format("D MMM Y")}</span>
                                                        </Box>
                                                    }
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={this.state.selectedAgent ? 3 : 2}>
                                    {/* <ShimmerContentBlock 
                                            mode="light" 
                                            rounded={1} 
                                            items={1} 
                                            itemsGap={10} 
                                            thumbnailHeight={"30px"} 
                                            thumbnailWidth={"30px"} 
                                            thumbnailRounded={1} 
                                            contentDetailsPosition="start" 
                                            contentDetailTextLines={3} 
                                        /> */}
                                        
                                    <Box sx={{border: "solid 1px #9f8003", backgroundColor: "#fbf4d1", p: "10px", borderRadius: "5px"}}>
                                        {/* {
                                            this.state.isLoadingClosingRateSummary && (<ShimmerCategoryItems mode="light" imageRounded={100}/>)
                                        } */}
                                        {/* {
                                            !this.state.isLoadingClosingRateSummary && ( */}
                                                <Box>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3} sx={{alignContent: "center"}}>
                                                            <AccessTime sx={{width: "30px", height: "30px", color: "#9f8003"}} />
                                                        </Grid>
                                                        <Grid item xs={9}>
                                                            <Box sx={{fontWeight: "bold", fontSize: '13px'}}>Closing Rate</Box>
                                                            {this.state.isLoadingClosingRateSummary && <ShimmerTitle mode="light" line={1} gap={21} width={20} />}
                                                            {!this.state.isLoadingClosingRateSummary && 
                                                                <Box sx={{fontWeight: "bold", color: "#000000", fontSize: "20px"}}>{this.state.closingRateSummaryData?.closingRate}%</Box>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Box>
                                                        {this.state.isLoadingClosingRateSummary && <ShimmerText mode="light" line={1} gap={5} />}
                                                        {!this.state.isLoadingClosingRateSummary && 
                                                            <Box>
                                                                {
                                                                    this.state.closingRateSummaryData?.isUp ? <ArrowUpward sx={{color: "#038516", width: "10px"}} /> : <ArrowDownward sx={{color: "#038516", width: "10px"}} />
                                                                }
                                                                <span style={{fontSize: "10px"}}>&nbsp;{this.state.closingRateSummaryData?.percentage}% dari {moment(this.state.closingRateSummaryData?.startDateLast30Days).tz("asia/jakarta").format("D MMM")} - {moment(this.state.closingRateSummaryData?.endDateLast30Days).tz("asia/jakarta").format("D MMM Y")}</span>
                                                            </Box>
                                                        }
                                                        
                                                    </Box>
                                                </Box>
                                            {/* )
                                        } */}
                                    </Box>
                                </Grid>
                                
                                <Grid item xs={this.state.selectedAgent ? 3 : 2}>
                                    <Box sx={{border: "solid 1px #9f0395", backgroundColor: "#f7d1fb", p: "10px", borderRadius: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3} sx={{alignContent: "center"}}>
                                                <Update sx={{width: "30px", height: "30px", color: "#9f0395"}} />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Box sx={{fontWeight: "bold", fontSize: '13px'}}>AVG 1'st Response</Box>
                                                
                                                    {this.state.isLoadingFirstResponseSummary && <ShimmerTitle mode="light" line={1} gap={21} width={20} />}
                                                    {!this.state.isLoadingFirstResponseSummary && 
                                                        <Box sx={{fontWeight: "bold", color: "#000000", fontSize: "20px"}}>{this.state.firstResponseSummaryData?.avgResponseFormatted ?? "N/A"}</Box>
                                                    }
                                            </Grid>
                                        </Grid>
                                        <Box>
                                            {this.state.isLoadingFirstResponseSummary && <ShimmerText mode="light" line={1} gap={5} />}
                                            {!this.state.isLoadingFirstResponseSummary && 
                                                <Box>
                                                    {
                                                        this.state.firstResponseSummaryData?.isUp ? <ArrowUpward sx={{color: "#038516", width: "10px"}} /> : <ArrowDownward sx={{color: "#038516", width: "10px"}} />
                                                    }
                                                    <span style={{fontSize: "10px"}}>&nbsp;{this.state.firstResponseSummaryData?.percentageFormatted} dari {moment(this.state.firstResponseSummaryData?.startDateLast30Days).tz("asia/jakarta").format("D MMM")} - {moment(this.state.firstResponseSummaryData?.endDateLast30Days).tz("asia/jakarta").format("D MMM Y")}</span>
                                                </Box>
                                            }
                                            
                                        </Box>
                                    </Box>
                                </Grid>
                                
                                <Grid item xs={this.state.selectedAgent ? 3 : 2}>
                                    <Box sx={{border: "solid 1px #9f0303", backgroundColor: "#fbd1d1", p: "10px", borderRadius: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3} sx={{alignContent: "center"}}>
                                                <Flag sx={{width: "30px", height: "30px", color: "#9f0303"}} />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Box sx={{fontWeight: "bold", fontSize: '13px'}}>Red Flag Agents</Box>
                                                {this.state.isLoadingAgentsPerforma && <ShimmerTitle mode="light" line={1} gap={21} width={20} />}
                                                    {!this.state.isLoadingAgentsPerforma && 
                                                        <Box sx={{fontWeight: "bold", color: "#000000", fontSize: "20px"}}>{this.state.redFlagAgentsData ?? 0} Agent</Box>
                                                    }
                                                
                                            </Grid>
                                        </Grid>
                                        <Box>
                                            {this.state.isLoadingAgentsPerforma && <ShimmerText mode="light" line={1} gap={5} />}
                                            {!this.state.isLoadingAgentsPerforma && <span style={{fontSize: "10px"}}>Lihat detail dibawah</span>}
                                            
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            {/* Summary Boxes */}

                            {/* Performa Agents */}
                            <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <strong>Performa Agent &nbsp; <Info /></strong>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{textAlign: "right", color: "#696968"}}>
                                            Urutkan berdasarkan score &nbsp;
                                            <MuiTooltip title={"Ascending"}>
                                                <Button disabled={this.state.isLoadingAgentsPerforma} onClick={() => this.setState({sortMethod: "ASC"})} size='small' color={this.state.sortMethod === "ASC" ? "primary" : "default"} variant={this.state.sortMethod === "ASC" ? "contained" : "outlined"} sx={{textTransform: "capitalize", minWidth: "30px", padding: "2px 2px"}}>
                                                    <ArrowUpward sx={{width: "16px"}} />
                                                </Button>
                                            </MuiTooltip>
                                            &nbsp;
                                            <MuiTooltip title={"Descending"}>
                                                <Button disabled={this.state.isLoadingAgentsPerforma} onClick={() => this.setState({sortMethod: "DESC"})} size='small' color={this.state.sortMethod === "DESC" ? "primary" : "default"} variant={this.state.sortMethod === "DESC" ? "contained" : "outlined"} sx={{textTransform: "capitalize", minWidth: "30px", padding: "2px 2px"}}>
                                                    <ArrowDownward sx={{width: "16px"}} />
                                                </Button>
                                            </MuiTooltip>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                    <TableContainer>
                                        <Table size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Agent</TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Score</TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>SLA<Box sx={{fontWeight: "normal", color: "#999996", fontSize: '11px', textAlign: "center"}}>First Response</Box></TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Follow Up<Box sx={{fontWeight: "normal", color: "#999996", fontSize: '11px', textAlign: "center"}}>Compliance</Box></TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>AI Suggestion<Box sx={{fontWeight: "normal", color: "#999996", fontSize: '11px', textAlign: "center"}}>Usage</Box></TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Alignment<Box sx={{fontWeight: "normal", color: "#999996", fontSize: '11px', textAlign: "center"}}>Guidance</Box></TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Leads<Box sx={{fontWeight: "normal", color: "#999996", fontSize: '11px', textAlign: "center"}}>Ditangani</Box></TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Red Flag</TableCell>
                                                    <TableCell sx={{fontWeight: "bold", textAlign: "center"}}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                
                                                {
                                                    this.state.agentsPerformaData?.byAgents?.sort((a, b) => {
                                                        if (this.state.sortMethod === "ASC") {
                                                            return a.scoreAgent - b.scoreAgent;
                                                        } else {
                                                            return b.scoreAgent - a.scoreAgent;
                                                        }
                                                    }).map((item, index) => {
                                                        return (
                                                            <TableRow key={`row-result-${index}`}>
                                                                <TableCell>
                                                                    <Grid container spacing={1}>
                                                                        <Grid item xs={3} sx={{alignContent: "center"}}>
                                                                            <Avatar sx={{width: "30px", height: "30px"}} />
                                                                        </Grid>
                                                                        <Grid item xs={9}>
                                                                            <Box sx={{fontWeight: "bold"}}>{item.agentName}</Box>
                                                                            <Box sx={{fontWeight: "normal", color: "#474747"}}><small>-</small></Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item.scoreAgent}
                                                                    <Box>
                                                                        <Slider
                                                                            size="small"
                                                                            value={item.scoreAgent}
                                                                            aria-label="Small"
                                                                            valueLabelDisplay="auto"
                                                                            color={this.getColor(item.scoreAgent)}
                                                                        />
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell sx={{textAlign: "center"}}>
                                                                    <Box>
                                                                    {item.slaPercentage <= 50 && <Close color='error' sx={{width: "15px", height: "15px"}} />}    
                                                                    {(item.slaPercentage > 50 && item.slaPercentage <= 80) && <Warning color='warning' sx={{width: "15px", height: "15px"}} />}    
                                                                    {item.slaPercentage > 80 && <CheckCircle color='success' sx={{width: "15px", height: "15px"}} />}    
                                                                    </Box>
                                                                    {item.slaPercentage}%
                                                                </TableCell>
                                                                <TableCell sx={{textAlign: "center"}}>{item.followupCompliancePercentage}%</TableCell>
                                                                <TableCell>
                                                                    {item.leadsUsingAiPercentage}%
                                                                    <Box>
                                                                        <Slider
                                                                            size="small"
                                                                            value={item.leadsUsingAiPercentage}
                                                                            aria-label="Small"
                                                                            valueLabelDisplay="auto"
                                                                            color={this.getColor(item.leadsUsingAiPercentage)}
                                                                            draggable={false}
                                                                            disabled={false}
                                                                        />
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {item.alignmentGuidancePercentage}%
                                                                    <Box>
                                                                        <Slider
                                                                            size="small"
                                                                            value={item.alignmentGuidancePercentage}
                                                                            aria-label="Small"
                                                                            valueLabelDisplay="auto"
                                                                            color={this.getColor(item.alignmentGuidancePercentage)}
                                                                            
                                                                        />
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell sx={{textAlign: "center"}}>{item.leads?.length}</TableCell>
                                                                <TableCell sx={{textAlign: "center"}}><Chip size='small' label={item.redFlagCount} color={item.redFlagCount <= 0 ? "success" : "error"} /></TableCell>
                                                                <TableCell sx={{textAlign: "center"}}>
                                                                    <IconButton onClick={() => this.handleSelectAgent(item)} color='primary' size='small'><MoreVert /></IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {
                                        this.state.isLoadingAgentsPerforma && (
                                            <Box sx={{fontWeight: "bold", textAlign: "center", pt: "10px", pb: "10px"}}>
                                            {/* <TableRow key={`row-result-loading`}>
                                                <TableCell colSpan={8}> */}
                                                    <LinearProgress sx={{mb: "10px"}} />
                                                    Please wait ...
                                               {/* </TableCell>
                                            </TableRow> */}
                                            </Box>
                                        )
                                    }
                                </Box>

                                <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                    charts
                                </Box>
                                <Grid container spacing={1} sx={{mt: "10px"}}>
                                    <Grid item xs={this.state.selectedAgent ? 6 : 4}>
                                        <Box sx={{fontWeight: "bold", mb: "10px", textAlign: "center"}}>Summary Alasan Tidak Closing <span style={{fontSize: "12px", color: "#797777"}}>(Semua Agent)</span></Box>
                                        {
                                            !this.state.isLoadingSummaryAlasanTidakClosingAllAgents && (
                                                <Doughnut data={this.state.summaryAlasanTidakClosingChartData} />
                                            )
                                        }

                                        {
                                            this.state.isLoadingSummaryAlasanTidakClosingAllAgents && (
                                                <Box sx={{fontWeight: "bold", textAlign: "center", pt: "10px", pb: "10px"}}>Loading ...</Box>
                                            )
                                        }
                                    </Grid>
                                    <Grid item xs={this.state.selectedAgent ? 6 : 4}>

                                        <Box sx={{fontWeight: "bold", mb: "10px", textAlign: "center"}}>Leads Temperature <span style={{fontSize: "12px", color: "#797777"}}>(Semua Agent)</span></Box>
                                        {
                                            !this.state.isLoadingSummaryLeadsTemperatureAllAgents && (
                                                <Bar data={this.state.summaryLeadsTemperatureChartData} />
                                            )
                                        }
                                        {
                                            this.state.isLoadingSummaryLeadsTemperatureAllAgents && (
                                                <Box sx={{fontWeight: "bold", textAlign: "center", pt: "10px", pb: "10px"}}>Loading ...</Box>
                                            )
                                        }
                                    </Grid>
                                    {
                                        !this.state.selectedAgent && (
                                            <Grid item xs={4}></Grid>
                                        )
                                    }
                                </Grid>
                            </Box>
                            {/* Performa Agents */}
                        </Box>
                        {/* Content */}
                    </Grid>

                    {/* Detail Agent */}
                    {
                        this.state.selectedAgent && (
                            <Grid item xs={4}>
                                <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={10}>
                                            <Typography variant='h6'>Detail Agent</Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{textAlign: "right"}}>
                                            <IconButton onClick={() => this.handleSelectAgent(null)} color='error'><Close /></IconButton>
                                        </Grid>
                                    </Grid>
                                    <Divider sx={{mt: "10px", mb: "10px"}} />
                                    <Grid container spacing={1}>
                                        <Grid item xs={2} sx={{alignContent: "center"}}>
                                            <Avatar sx={{width: "30px", height: "30px"}} />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Box sx={{fontWeight: "bold"}}>{this.state.selectedAgent?.agentName}</Box>
                                            <Box sx={{fontWeight: "normal", color: "#474747"}}><small>-</small></Box>
                                            <Chip label={this.state.selectedAgent?.levelScoreAgent} color={this.getColor(this.state.selectedAgent?.scoreAgent)} size='small'  sx={{height: "16px", fontSize: "10px"}}/>
                                        </Grid>
                                        <Grid item xs={2} sx={{textAlign: "center", fontWeight: "bold"}}>
                                            Score
                                            <Box sx={{fontSize: "20px"}}>{this.state.selectedAgent?.scoreAgent}</Box>
                                        </Grid>
                                    </Grid>
                                    <Divider sx={{mt: "10px", mb: "10px"}} />
                                    <Typography variant='h6'>Breakdown Score <InfoOutlined sx={{color: "#9c9c9b", width: "16px"}} /></Typography>
                                    <Box>
                                        <Grid container spacing={0} sx={{mt: "10px"}}>
                                            <Grid item xs={10} sx={{fontWeight: "bold"}}>
                                                SLA First Response
                                            </Grid>
                                            <Grid item xs={2} sx={{fontWeight: "bold"}}>
                                                {this.state.selectedAgent?.slaPercentage}%
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Slider
                                                    size="small"
                                                    value={this.state.selectedAgent?.slaPercentage}
                                                    aria-label="Small"
                                                    valueLabelDisplay="auto"
                                                    color={this.getColor(this.state.selectedAgent?.slaPercentage)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={{mt: "5px"}}>
                                            <Grid item xs={10} sx={{fontWeight: "bold"}}>
                                                Follow-Up Compliance
                                            </Grid>
                                            <Grid item xs={2} sx={{fontWeight: "bold"}}>
                                                {this.state.selectedAgent?.followupCompliancePercentage}%
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Slider
                                                    size="small"
                                                    value={this.state.selectedAgent?.followupCompliancePercentage}
                                                    aria-label="Small"
                                                    valueLabelDisplay="auto"
                                                    color={this.getColor(this.state.selectedAgent?.followupCompliancePercentage)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={{mt: "5px"}}>
                                            <Grid item xs={10} sx={{fontWeight: "bold"}}>
                                                AI Suggestion Usage
                                            </Grid>
                                            <Grid item xs={2} sx={{fontWeight: "bold"}}>
                                                {this.state.selectedAgent?.leadsUsingAiPercentage}%
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Slider
                                                    size="small"
                                                    value={this.state.selectedAgent?.leadsUsingAiPercentage}
                                                    aria-label="Small"
                                                    valueLabelDisplay="auto"
                                                    color={this.getColor(this.state.selectedAgent?.leadsUsingAiPercentage)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={{mt: "5px"}}>
                                            <Grid item xs={10} sx={{fontWeight: "bold"}}>
                                                Alignment (Guidance)
                                            </Grid>
                                            <Grid item xs={2} sx={{fontWeight: "bold"}}>
                                                {this.state.selectedAgent?.alignmentGuidancePercentage}%
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Slider
                                                    size="small"
                                                    value={this.state.selectedAgent?.alignmentGuidancePercentage}
                                                    aria-label="Small"
                                                    valueLabelDisplay="auto"
                                                    color={this.getColor(this.state.selectedAgent?.alignmentGuidancePercentage)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={{mt: "5px"}}>
                                            <Grid item xs={10} sx={{fontWeight: "bold"}}>
                                                Volume Leads
                                            </Grid>
                                            <Grid item xs={2} sx={{fontWeight: "bold"}}>
                                                {this.state.selectedAgent?.leadsPercentage}%
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Slider
                                                    size="small"
                                                    value={this.state.selectedAgent?.leadsPercentage}
                                                    aria-label="Small"
                                                    valueLabelDisplay="auto"
                                                    color={"primary"}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    {/* Red Flag */}
                                    <Typography variant='h6' sx={{color: "#ea0505"}}>Red Flag ({this.state.selectedAgent?.redFlagCount})</Typography>
                                    <Box>
                                        {
                                            this.state.selectedAgent?.slaPercentage < 50 && (
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMore />}
                                                        aria-controls={`panel1-content`}
                                                        id={`panel1-header`}
                                                    >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={10}>
                                                            <Typography component="span" sx={{fontSize: "13px"}}>First Response &gt; 1 menit</Typography>
                                                        </Grid>
                                                        <Grid item xs={2} textAlign={"right"}>
                                                            <Chip sx={{fontSize: "10px", height: "17px"}} label={this.state.selectedAgent?.responseMore1MinuteCount} color='error' variant='outlined' size='small' />
                                                        </Grid>
                                                    </Grid>
                                                    </AccordionSummary>
                                                        <AccordionDetails>
                                                    </AccordionDetails>
                                                </Accordion>
                                            )
                                        }
                                        {
                                            (this.state.selectedAgent?.followupCompliancePercentage) < 50 && (
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMore />}
                                                        aria-controls={`panel2-content`}
                                                        id={`panel2-header`}
                                                    >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={10}>
                                                            <Typography component="span" sx={{fontSize: "13px"}}>Tidak Follow-up Sesuai SOP</Typography>
                                                        </Grid>
                                                        <Grid item xs={2} textAlign={"right"}>
                                                            <Chip sx={{fontSize: "10px", height: "17px"}} label={(this.state.selectedAgent?.customerPendingWajibFu - this.state.selectedAgent?.customerPendingWajibFuDiFu) + "x"} color='error' variant='outlined' size='small' />
                                                        </Grid>
                                                    </Grid>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                    </AccordionDetails>
                                                </Accordion>
                                            )
                                        }
                                        {
                                            this.state.selectedAgent?.leadsUsingAiPercentage < 50 && (
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMore />}
                                                        aria-controls={`panel3-content`}
                                                        id={`panel3-header`}
                                                    >
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={10}>
                                                            <Typography component="span" sx={{fontSize: "13px"}}>Deviasi AI Suggestion</Typography>
                                                        </Grid>
                                                        <Grid item xs={2} textAlign={"right"}>
                                                            <Chip 
                                                                sx={{fontSize: "10px", height: "17px"}} 
                                                                label={this.state.selectedAgent?.leadsUsingAiPercentage <= 50 ? "Tinggi" : this.state.selectedAgent?.leadsUsingAiPercentage <= 80 ? "Sedang" : "Rendah"} 
                                                                color={this.getColor(this.state.selectedAgent?.leadsUsingAiPercentage)} 
                                                                variant='outlined' 
                                                                size='small' 
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                    </AccordionDetails>
                                                </Accordion>
                                            )
                                        }
                                    </Box>
                                    {/* Red Flag */}

                                </Box>

                                {/* Top NO Closing Reason */}
                                <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                    <Typography variant='h6'>Top No Closing (Agent Ini)</Typography>
                                    <br />
                                    {this.state.isLoadingSummaryAlasanTidakClosingAgents && <ShimmerText mode="light" line={5} gap={5} />}
                                    {
                                        !this.state.isLoadingSummaryAlasanTidakClosingAgents && this.state.selectedAgent?.summaryAlasanTidakClosingData?.map((item, index) => {
                                            
                                            if(!item?.count){
                                                return null; // Skip rendering if count is not available
                                            }
                                            
                                            return (
                                                <Box key={`top-no-closing-${index}`}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={7}>
                                                            {`${index+1}. ${item.alasan_tidak_closing}`}
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Grid container spacing={0}>
                                                                <Grid item xs={6}>
                                                                    <Slider
                                                                        size="small"
                                                                        value={item.count}
                                                                        aria-label="Small"
                                                                        valueLabelDisplay="auto"
                                                                        color={this.getColor(0)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    {item.count} Leads
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            );
                                        })
                                    }
                                    <Button onClick={this.handleShowDialog} variant='outlined' color='primary' fullWidth sx={{textTransform: "capitalize"}}>
                                        Lihat Detail Chat &amp; Coaching
                                    </Button>
                                </Box>
                                {/* Top NO Closing Reason */}

                                {/* Coaching Result */}
                                 <Box sx={{border: "solid 1px #dededd", borderRadius: "5px", mt: "10px", p: "10px"}}>
                                    <Typography variant='h6'>Catatan Coaching</Typography>
                                    <TextField
                                        id="outlined-basic"
                                        // label=""
                                        placeholder='Tulis catatan coaching untuk agent ini ...'
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        value={this.state.selectedAgent?.coachingNote || ''}
                                        onChange={this.handleCoachingNoteChange}
                                    />
                                </Box>
                                {/* Coaching Result */}
                            </Grid>
                        )
                    }
                    {/* Detail Agent */}

                </Grid>

                <Dialog
                    open={this.state.showDialog}
                    onClose={() => this.setState({showDialog: false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    role="alertdialog"
                    maxWidth={"lg"}
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">
                        <Grid container spacing={1}>
                            <Grid item xs={10}>
                                Customer Tidak Closing
                            </Grid>
                            <Grid item xs={2} textAlign={"right"}>
                                <IconButton onClick={() => this.setState({showDialog: false})} color='error'><Close /></IconButton>
                            </Grid>
                        </Grid>
                        <Divider />
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.selectedAgent && (
                                <ChatViewer selectedAgent={this.state.selectedAgent} />
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        {/* <Button onClick={() => this.setState({showDialog: false})} autoFocus>
                            Disagree
                        </Button>
                        <Button onClick={() => this.setState({showDialog: false})}>Agree</Button> */}
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}
 
export default SpvControlPanel;